import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { memo as _$memo } from "@opentui/solid";
import { use as _$use } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { TextAttributes } from "@opentui/core";
import { useTheme } from "../context/theme";
import { useDialog } from "./dialog";
import { createStore } from "solid-js/store";
import { onMount, Show } from "solid-js";
import { useKeyboard } from "@opentui/solid";
export function DialogExportOptions(props) {
  const dialog = useDialog();
  const {
    theme
  } = useTheme();
  let textarea;
  const [store, setStore] = createStore({
    thinking: props.defaultThinking,
    toolDetails: props.defaultToolDetails,
    assistantMetadata: props.defaultAssistantMetadata,
    openWithoutSaving: props.defaultOpenWithoutSaving,
    active: "filename"
  });
  useKeyboard(evt => {
    if (evt.name === "return") {
      props.onConfirm?.({
        filename: textarea.plainText,
        thinking: store.thinking,
        toolDetails: store.toolDetails,
        assistantMetadata: store.assistantMetadata,
        openWithoutSaving: store.openWithoutSaving
      });
    }
    if (evt.name === "tab") {
      const order = ["filename", "thinking", "toolDetails", "assistantMetadata", "openWithoutSaving"];
      const currentIndex = order.indexOf(store.active);
      const nextIndex = (currentIndex + 1) % order.length;
      setStore("active", order[nextIndex]);
      evt.preventDefault();
    }
    if (evt.name === "space" || evt.name === " ") {
      if (store.active === "thinking") setStore("thinking", !store.thinking);
      if (store.active === "toolDetails") setStore("toolDetails", !store.toolDetails);
      if (store.active === "assistantMetadata") setStore("assistantMetadata", !store.assistantMetadata);
      if (store.active === "openWithoutSaving") setStore("openWithoutSaving", !store.openWithoutSaving);
      evt.preventDefault();
    }
  });
  onMount(() => {
    dialog.setSize("medium");
    setTimeout(() => {
      if (!textarea || textarea.isDestroyed) return;
      textarea.focus();
    }, 1);
    textarea.gotoLineEnd();
  });
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("box"),
      _el$3 = _$createElement("text"),
      _el$5 = _$createElement("text"),
      _el$7 = _$createElement("box"),
      _el$8 = _$createElement("box"),
      _el$9 = _$createElement("text"),
      _el$1 = _$createElement("textarea"),
      _el$10 = _$createElement("box"),
      _el$11 = _$createElement("box"),
      _el$12 = _$createElement("text"),
      _el$13 = _$createElement("text"),
      _el$15 = _$createElement("box"),
      _el$16 = _$createElement("text"),
      _el$17 = _$createElement("text"),
      _el$19 = _$createElement("box"),
      _el$20 = _$createElement("text"),
      _el$21 = _$createElement("text"),
      _el$23 = _$createElement("box"),
      _el$24 = _$createElement("text"),
      _el$25 = _$createElement("text");
    _$insertNode(_el$, _el$2);
    _$insertNode(_el$, _el$7);
    _$insertNode(_el$, _el$10);
    _$setProp(_el$, "paddingLeft", 2);
    _$setProp(_el$, "paddingRight", 2);
    _$setProp(_el$, "gap", 1);
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$5);
    _$setProp(_el$2, "flexDirection", "row");
    _$setProp(_el$2, "justifyContent", "space-between");
    _$insertNode(_el$3, _$createTextNode(`Export Options`));
    _$insertNode(_el$5, _$createTextNode(`esc`));
    _$setProp(_el$5, "onMouseUp", () => dialog.clear());
    _$insertNode(_el$7, _el$8);
    _$insertNode(_el$7, _el$1);
    _$setProp(_el$7, "gap", 1);
    _$insertNode(_el$8, _el$9);
    _$insertNode(_el$9, _$createTextNode(`Filename:`));
    _$use(val => textarea = val, _el$1);
    _$setProp(_el$1, "onSubmit", () => {
      props.onConfirm?.({
        filename: textarea.plainText,
        thinking: store.thinking,
        toolDetails: store.toolDetails,
        assistantMetadata: store.assistantMetadata,
        openWithoutSaving: store.openWithoutSaving
      });
    });
    _$setProp(_el$1, "height", 3);
    _$setProp(_el$1, "keyBindings", [{
      name: "return",
      action: "submit"
    }]);
    _$setProp(_el$1, "placeholder", "Enter filename");
    _$insertNode(_el$10, _el$11);
    _$insertNode(_el$10, _el$15);
    _$insertNode(_el$10, _el$19);
    _$insertNode(_el$10, _el$23);
    _$setProp(_el$10, "flexDirection", "column");
    _$insertNode(_el$11, _el$12);
    _$insertNode(_el$11, _el$13);
    _$setProp(_el$11, "flexDirection", "row");
    _$setProp(_el$11, "gap", 2);
    _$setProp(_el$11, "paddingLeft", 1);
    _$setProp(_el$11, "onMouseUp", () => setStore("active", "thinking"));
    _$insert(_el$12, () => store.thinking ? "[x]" : "[ ]");
    _$insertNode(_el$13, _$createTextNode(`Include thinking`));
    _$insertNode(_el$15, _el$16);
    _$insertNode(_el$15, _el$17);
    _$setProp(_el$15, "flexDirection", "row");
    _$setProp(_el$15, "gap", 2);
    _$setProp(_el$15, "paddingLeft", 1);
    _$setProp(_el$15, "onMouseUp", () => setStore("active", "toolDetails"));
    _$insert(_el$16, () => store.toolDetails ? "[x]" : "[ ]");
    _$insertNode(_el$17, _$createTextNode(`Include tool details`));
    _$insertNode(_el$19, _el$20);
    _$insertNode(_el$19, _el$21);
    _$setProp(_el$19, "flexDirection", "row");
    _$setProp(_el$19, "gap", 2);
    _$setProp(_el$19, "paddingLeft", 1);
    _$setProp(_el$19, "onMouseUp", () => setStore("active", "assistantMetadata"));
    _$insert(_el$20, () => store.assistantMetadata ? "[x]" : "[ ]");
    _$insertNode(_el$21, _$createTextNode(`Include assistant metadata`));
    _$insertNode(_el$23, _el$24);
    _$insertNode(_el$23, _el$25);
    _$setProp(_el$23, "flexDirection", "row");
    _$setProp(_el$23, "gap", 2);
    _$setProp(_el$23, "paddingLeft", 1);
    _$setProp(_el$23, "onMouseUp", () => setStore("active", "openWithoutSaving"));
    _$insert(_el$24, () => store.openWithoutSaving ? "[x]" : "[ ]");
    _$insertNode(_el$25, _$createTextNode(`Open without saving`));
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return store.active !== "filename";
      },
      get children() {
        var _el$27 = _$createElement("text"),
          _el$28 = _$createTextNode(`Press `),
          _el$29 = _$createElement("span"),
          _el$31 = _$createTextNode(` to toggle, `),
          _el$32 = _$createElement("span"),
          _el$34 = _$createTextNode(` to confirm`);
        _$insertNode(_el$27, _el$28);
        _$insertNode(_el$27, _el$29);
        _$insertNode(_el$27, _el$31);
        _$insertNode(_el$27, _el$32);
        _$insertNode(_el$27, _el$34);
        _$setProp(_el$27, "paddingBottom", 1);
        _$insertNode(_el$29, _$createTextNode(`space`));
        _$insertNode(_el$32, _$createTextNode(`return`));
        _$effect(_p$ => {
          var _v$ = theme.textMuted,
            _v$2 = {
              fg: theme.text
            },
            _v$3 = {
              fg: theme.text
            };
          _v$ !== _p$.e && (_p$.e = _$setProp(_el$27, "fg", _v$, _p$.e));
          _v$2 !== _p$.t && (_p$.t = _$setProp(_el$29, "style", _v$2, _p$.t));
          _v$3 !== _p$.a && (_p$.a = _$setProp(_el$32, "style", _v$3, _p$.a));
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$27;
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return store.active === "filename";
      },
      get children() {
        var _el$36 = _$createElement("text"),
          _el$37 = _$createTextNode(`Press `),
          _el$38 = _$createElement("span"),
          _el$40 = _$createTextNode(` to confirm, `),
          _el$41 = _$createElement("span"),
          _el$43 = _$createTextNode(` for options`);
        _$insertNode(_el$36, _el$37);
        _$insertNode(_el$36, _el$38);
        _$insertNode(_el$36, _el$40);
        _$insertNode(_el$36, _el$41);
        _$insertNode(_el$36, _el$43);
        _$setProp(_el$36, "paddingBottom", 1);
        _$insertNode(_el$38, _$createTextNode(`return`));
        _$insertNode(_el$41, _$createTextNode(`tab`));
        _$effect(_p$ => {
          var _v$4 = theme.textMuted,
            _v$5 = {
              fg: theme.text
            },
            _v$6 = {
              fg: theme.text
            };
          _v$4 !== _p$.e && (_p$.e = _$setProp(_el$36, "fg", _v$4, _p$.e));
          _v$5 !== _p$.t && (_p$.t = _$setProp(_el$38, "style", _v$5, _p$.t));
          _v$6 !== _p$.a && (_p$.a = _$setProp(_el$41, "style", _v$6, _p$.a));
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$36;
      }
    }), null);
    _$effect(_p$ => {
      var _v$7 = TextAttributes.BOLD,
        _v$8 = theme.text,
        _v$9 = theme.textMuted,
        _v$0 = theme.text,
        _v$1 = props.defaultFilename,
        _v$10 = theme.text,
        _v$11 = theme.text,
        _v$12 = theme.text,
        _v$13 = store.active === "thinking" ? theme.backgroundElement : undefined,
        _v$14 = store.active === "thinking" ? theme.primary : theme.textMuted,
        _v$15 = store.active === "thinking" ? theme.primary : theme.text,
        _v$16 = store.active === "toolDetails" ? theme.backgroundElement : undefined,
        _v$17 = store.active === "toolDetails" ? theme.primary : theme.textMuted,
        _v$18 = store.active === "toolDetails" ? theme.primary : theme.text,
        _v$19 = store.active === "assistantMetadata" ? theme.backgroundElement : undefined,
        _v$20 = store.active === "assistantMetadata" ? theme.primary : theme.textMuted,
        _v$21 = store.active === "assistantMetadata" ? theme.primary : theme.text,
        _v$22 = store.active === "openWithoutSaving" ? theme.backgroundElement : undefined,
        _v$23 = store.active === "openWithoutSaving" ? theme.primary : theme.textMuted,
        _v$24 = store.active === "openWithoutSaving" ? theme.primary : theme.text;
      _v$7 !== _p$.e && (_p$.e = _$setProp(_el$3, "attributes", _v$7, _p$.e));
      _v$8 !== _p$.t && (_p$.t = _$setProp(_el$3, "fg", _v$8, _p$.t));
      _v$9 !== _p$.a && (_p$.a = _$setProp(_el$5, "fg", _v$9, _p$.a));
      _v$0 !== _p$.o && (_p$.o = _$setProp(_el$9, "fg", _v$0, _p$.o));
      _v$1 !== _p$.i && (_p$.i = _$setProp(_el$1, "initialValue", _v$1, _p$.i));
      _v$10 !== _p$.n && (_p$.n = _$setProp(_el$1, "textColor", _v$10, _p$.n));
      _v$11 !== _p$.s && (_p$.s = _$setProp(_el$1, "focusedTextColor", _v$11, _p$.s));
      _v$12 !== _p$.h && (_p$.h = _$setProp(_el$1, "cursorColor", _v$12, _p$.h));
      _v$13 !== _p$.r && (_p$.r = _$setProp(_el$11, "backgroundColor", _v$13, _p$.r));
      _v$14 !== _p$.d && (_p$.d = _$setProp(_el$12, "fg", _v$14, _p$.d));
      _v$15 !== _p$.l && (_p$.l = _$setProp(_el$13, "fg", _v$15, _p$.l));
      _v$16 !== _p$.u && (_p$.u = _$setProp(_el$15, "backgroundColor", _v$16, _p$.u));
      _v$17 !== _p$.c && (_p$.c = _$setProp(_el$16, "fg", _v$17, _p$.c));
      _v$18 !== _p$.w && (_p$.w = _$setProp(_el$17, "fg", _v$18, _p$.w));
      _v$19 !== _p$.m && (_p$.m = _$setProp(_el$19, "backgroundColor", _v$19, _p$.m));
      _v$20 !== _p$.f && (_p$.f = _$setProp(_el$20, "fg", _v$20, _p$.f));
      _v$21 !== _p$.y && (_p$.y = _$setProp(_el$21, "fg", _v$21, _p$.y));
      _v$22 !== _p$.g && (_p$.g = _$setProp(_el$23, "backgroundColor", _v$22, _p$.g));
      _v$23 !== _p$.p && (_p$.p = _$setProp(_el$24, "fg", _v$23, _p$.p));
      _v$24 !== _p$.b && (_p$.b = _$setProp(_el$25, "fg", _v$24, _p$.b));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined,
      h: undefined,
      r: undefined,
      d: undefined,
      l: undefined,
      u: undefined,
      c: undefined,
      w: undefined,
      m: undefined,
      f: undefined,
      y: undefined,
      g: undefined,
      p: undefined,
      b: undefined
    });
    return _el$;
  })();
}
DialogExportOptions.show = (dialog, defaultFilename, defaultThinking, defaultToolDetails, defaultAssistantMetadata, defaultOpenWithoutSaving) => {
  return new Promise(resolve => {
    dialog.replace(() => _$createComponent(DialogExportOptions, {
      defaultFilename: defaultFilename,
      defaultThinking: defaultThinking,
      defaultToolDetails: defaultToolDetails,
      defaultAssistantMetadata: defaultAssistantMetadata,
      defaultOpenWithoutSaving: defaultOpenWithoutSaving,
      onConfirm: options => resolve(options),
      onCancel: () => resolve(null)
    }), () => resolve(null));
  });
};